// src/platform/dashboards/dashboardRegistry.js
//
// key → dashboard component.
//
// The API owns which dashboards EXIST and what their cards say; this file owns
// what each one renders when opened. Adding a dashboard is therefore two edits,
// one on each side, and neither the landing page nor the admin shell needs
// touching:
//
//   1. admin-api/routes/aiDashboards.mjs — add a DASHBOARDS entry (title,
//      subtitle, rollup, detail)
//   2. here — add the component under the same key
//
// A key the API returns but this file does not know is not an error; it falls
// back to UnbuiltDashboard, which explains itself. See that file for why.
//
// Plain .js, and it exports no component of its own — a module that mixes
// component and value exports loses fast refresh for everything in it.

import WellfinderReviewDashboard from "./WellfinderReviewDashboard";
import UnbuiltDashboard from "./UnbuiltDashboard";

export const DASHBOARD_COMPONENTS = {
  "wellfinder-review": WellfinderReviewDashboard,
};

export function resolveDashboard(key) {
  return DASHBOARD_COMPONENTS[key] ?? UnbuiltDashboard;
}
